import React, { Component } from "react";
import { message, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { getToken } from "../../core/auth";
import { getUrl } from "../../service/oss";
import { getServerOSS } from "../../core/options";
import { Modal } from "@/nano";

import "./index.less";

const DEFAULT_ACCEPT = "";

export default class FileListUpload extends Component {
  state = {
    fileList: [],
  };

  headers = {
    Authorization: getToken(),
  };

  componentDidMount() {
    this.refreshFileList();
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { value } = this.props;
    if (value !== nextProps.value) {
      this.refreshFileList(nextProps);
    }
    return true;
  }

  refreshFileList = (props = this.props) => {
    const value = props.value || "";
    const paths = value.split(",").map(v => v.trim()).filter(v => v);
    const fileList = paths.map((path) => {
      return {
        uid: path,
        status: "done",
        url: getUrl(path),
        response: { data: { path } },
        name: path.substring(path.lastIndexOf("/") + 1),
      };
    });
    this.setState({
      ...this.state,
      fileList,
    });
  };

  getAccept = () => {
    return this.props.accept || DEFAULT_ACCEPT;
  };

  getUploadURL = () => {
    return getServerOSS().uploadURL;
  };

  onChange = (e) => {
    const { file, fileList } = e;
    if ("uploading" === file.status) {
      this.setState({
        ...this.state,
        fileList,
      });
      return;
    }

    if ("removed" === file.status) {
      Modal.confirm({
        title: "是否确认删除？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.setState(
            {
              ...this.state,
              fileList,
            },
            () => this.fireChange(e)
          );
          return;
        },
        onCancel: () => {
          return false;
        }
      })
    }

    if ("done" === file.status) {
      const { code } = file.response;
      if (200 === code) {
        this.setState(
          {
            ...this.state,
            fileList,
          },
          () => this.fireChange(e)
        );
        return;
      } else {
        this.setState(
          {
            ...this.state,
            fileList: fileList.filter((item) => item.uid !== file.uid),
          },
          () => this.fireChange(e)
        );
        return;
      }
    }
  };

  fireChange = (e) => {
    const { fileList } = this.state;
    const paths = fileList.map((file) => {
      return file.response.data.path;
    });
    this.props.onChange && this.props.onChange(paths.join(","), e);
  };

  onBeforeUpload = (file) => {
    const accept = this.getAccept();
    const splits = file.name.split(".");
    if (accept && -1 === accept.indexOf(splits[splits.length - 1])) {
      message.error("请检查文件类型!");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("上传文件超过2M!");
      return false;
    }
    return true;
  };

  onPreview = (file) => {
    // if (!file.url && !file.preview) {
    //   getBase64(file.originFileObj).then(res => {
    //     file.preview = res;
    //     this.setPreview(file);
    //   }).catch(() => {
    //     this.setPreview(file);
    //   })
    //   return;
    // }
    // this.setPreview(file);
    let path = file.response.data.path;
    path = 0 === path.indexOf("/") ? path : `/${path}`
    window.open(getUrl(path));
  };

  render() {
    const { fileList } = this.state;
    return (
      <Upload
        name="file"
        fileList={fileList}
        headers={this.headers}
        accept={this.getAccept()}
        action={this.getUploadURL()}
        onPreview={this.onPreview}
        beforeUpload={this.onBeforeUpload}
        {...this.props}
        onChange={this.onChange}
      >
        <Button icon={<UploadOutlined />}>点击上传</Button>
      </Upload>
    );
  }
}
